import { appConfig } from '../config'

export function createForm (action: string, formData: Record<string, any>): HTMLFormElement {
  const form = document.createElement('form')
  form.setAttribute('method', 'post')
  form.setAttribute('action', action)
  form.style.display = 'none'

  Object.keys(formData).forEach((name) => {
    const inputField = document.createElement('input')
    const value = (formData as any)[name]
    inputField.setAttribute('type', 'hidden')
    inputField.setAttribute('name', name)
    inputField.setAttribute('value', value === false ? '' : String(value))
    form.appendChild(inputField)
  })

  const submitButton = document.createElement('input')
  submitButton.setAttribute('type', 'submit')
  form.appendChild(submitButton)

  document.getElementsByTagName('body')[0].appendChild(form)

  return form
}

export function submitLoginForm (formData: Record<string, any>) {
  const form = createForm(appConfig.apiBaseUrl + '/login', formData)
  form.submit()
}
